import { connect } from 'react-redux';

import BaseLanguages from './BaseLanguages';
import { trackFilterClickLanguage } from '../../../../actions';

const mapDispatchToProps = {
    trackFilterClickLanguage,
};

export default connect(undefined, mapDispatchToProps)(BaseLanguages);
